import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
	chosenKilometrageSelector,
	leaseCarDataAvailableKilometragesSelector,
} from '../../../../../../store/selectors';
import { formatKilometrageDescription, getValueFromCookie } from '../../../../../../utils';

export const useFormattedKilometrageLabel = () => {
	const availableKilometrages = useSelector(leaseCarDataAvailableKilometragesSelector);
	const selectedKilometrage = useSelector(chosenKilometrageSelector);

	return useMemo(() => {
		const kilometrageFromCookie = getValueFromCookie('kilometrage');
		const resolvedKilometrage = selectedKilometrage || kilometrageFromCookie;

		if (!resolvedKilometrage) return '';
		const kilometrageLabel = availableKilometrages?.find(
			(k: { mileage: number; description: string }) => String(k.mileage) === resolvedKilometrage
		)?.description;

		return kilometrageLabel
			? `${formatKilometrageDescription(kilometrageLabel)} km`
			: resolvedKilometrage;
	}, [availableKilometrages, selectedKilometrage]);
};
